/**
 * @generated SignedSource<<3d335b8a69a29e698147ae05ae217cca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteeRelationship = "MANAGER" | "SUBORDINATE" | "TEAMMATE";
export type InviteUsersMutationInput = {
  analytics: string;
  captchaToken: string;
  clientMutationId?: string | null;
  invitations: ReadonlyArray<InviteUserInput | null>;
};
export type InviteUserInput = {
  email: string;
  fullName: string;
  oneOnOneDetails?: InviteOneOnOneInput | null;
  relationship?: InviteeRelationship | null;
  sendInviteEmail?: boolean | null;
};
export type InviteOneOnOneInput = {
  eventEnd?: string | null;
  eventId?: string | null;
  eventStart?: string | null;
};
export type InvitePageContactMutation$variables = {
  input: InviteUsersMutationInput;
};
export type InvitePageContactMutation$data = {
  readonly inviteUsers: {
    readonly invitees: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly field: string | null;
        readonly message: string;
      } | null> | null;
    }>;
  } | null;
};
export type InvitePageContactMutation = {
  response: InvitePageContactMutation$data;
  variables: InvitePageContactMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteUsersMutationPayload",
    "kind": "LinkedField",
    "name": "inviteUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InviteUserOutput",
        "kind": "LinkedField",
        "name": "invitees",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitePageContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitePageContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db79cbe09dc10bec57d032cbe3bf7d12",
    "id": null,
    "metadata": {},
    "name": "InvitePageContactMutation",
    "operationKind": "mutation",
    "text": "mutation InvitePageContactMutation(\n  $input: InviteUsersMutationInput!\n) {\n  inviteUsers(input: $input) {\n    invitees {\n      errors {\n        field\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "95586b1544ceb6b4bf60a7879d3502da";

export default node;
